<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col>
					<b-form-select v-model="departmentId" name="departmentId">
						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt"
							:value="selectOption.id">{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null" disabled>
								-- {{ $t('priceControl.departments') }} --
							</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col>
					<date-picker v-model="fromDate" lang="ru" style="width: 100%"
						:placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col>
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')"
						value-type="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col cols="2">
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-3" />
					<!-- <b-button @click="print" variant="outline-dark" class="fa fa-print" /> -->
				</b-col>
			</b-row>
			<hr class="mt-4">
		</div>
		<b-card-body>
			<highcharts v-if="isVisible" :options="chartOptions" style="margin-top: 50px"></highcharts>
		</b-card-body>
	</b-card>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Multiselect from "vue-multiselect";
import UsersService from "../../../services/users.sevice";
import { TokenService } from "../../../services/storage.service";
import ReportService from "./report.service";

export default {
	name: "Товарный отчет за период",
	components: {
		Multiselect,
		highcharts: Chart
	},
	data() {
		return {
			items: [],
			isVisible: false,
			fromDate: null,
			toDate: null,
			departments: [],
			departmentId: null,
			departmentName: '',
			groupList: [],
			loading: false
		};
	},
	computed: {
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		},
		groupName() {
			return this.groupList.map(item => {
				return {
					name: item.groupName,
					y: item.value,
					drilldown: item.groupName
				}
			})
		}
		, chartOptions() {
			return {
				chart: {
					type: 'column'
				},
				title: {
					align: 'center',
					text: `Выручка с (${this.fromDate || ''}) по (${this.toDate || ''})`
				},
				accessibility: {
					announceNewData: {
						enabled: true
					}
				},
				xAxis: {
					type: 'category',
					labels: {
						useHTML: true,
						formatter: function () {
							// Agar data point children ichida weekDay bo‘lsa
							const point = this.chart.series[0].data.find(p => p.name === this.value);
							let weekDay = '';
							if (point && point.children && point.children.length > 0) {
								weekDay = point.children[0].weekDay;
							}

							return `
        <div style="text-align:center">
          <b>${this.value}</b><br/>
          <span style="font-size: 11px; color: gray">${weekDay}</span>
        </div>
      `;
						}
					}
				},
				yAxis: {
					title: {
						text: ''
					}
				},
				legend: {
					enabled: false
				},
				plotOptions: {
					series: {
						borderWidth: 0,
						dataLabels: {
							enabled: true,
							format: '<b style="color:{point.color}">{point.y:.2f}</b>'
						}
					}
				},
				tooltip: {
					useHTML: true,
					formatter: function () {
						let weekDay = "";
						if (this.point.children && this.point.children.length > 0) {
							weekDay = this.point.children[0].weekDay;
						}

						let childrenHtml = "";
						if (this.point.children) {
							childrenHtml = "<br/><b>Подробно:</b><br/>" + this.point.children.sort((a, b) => b.saleTotalSum - a.saleTotalSum)
								.map(ch => `${ch.categoryName} - ${ch.saleTotalSum.toFixed(2)}`)
								.join("<br/>");
						}

						return `
      <b>${this.point.name}</b>: ${this.point.y.toFixed(2)}<br/>
      <i>${weekDay}</i><br/>
      ${childrenHtml}
    `;
					}
				},
				series: [
					{
						name: 'Продажи',
						colorByPoint: true,
						data: this.groupList.map(item => ({
							name: item.groupName,
							y: item.value,
							children: item.children // ⚡ Tooltippga uzatamiz
						}))
					},
				],
			}
		}
	},
	methods: {
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		async getItems() {
			this.loading = true
			if (this.departmentId && this.fromDate && this.toDate) {
				this.isVisible = true
				let data = {
					endDate: this.toDate,
					startDate: this.fromDate,
					departmentId: this.departmentId,
				}
				await ReportService.getTotalSaleByPeriodAndDepartment(data).then(res => {
					this.items = res.data

					// 🔹 JSONni grafik uchun tayyorlash

					// this.groupList = this.items.map(item => {
					// 	return {
					// 		groupName: item.saleDate,
					// 		value: item.saleTotalSum
					// 	}
					// })

					this.groupList = Object.values(
						this.items.reduce((acc, item) => {
							const date = item.saleDate;

							if (!acc[date]) {
								acc[date] = {
									groupName: date,
									value: 0,
									children: []
								};
							}

							acc[date].value += (item.saleTotalSum || 0);
							acc[date].children.push(item);

							return acc;
						}, {})
					);

					console.log(this.groupList);

					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: this.$t('words.error'),
						text: e,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		this.getDeps();
	}
}
</script>
